module.exports = __webpack_public_path__ + "static/img/animals6.7c2bfc55.png";